class DSArticleContent extends HTMLElement {
  connectedCallback() {
    this.generateNavigationMenu();
  }

  generateNavigationMenu() {
    const headings = Array.from(this.querySelectorAll('h2'));

    if (headings.length === 0) {
      console.warn('Keine Absätze vorhanden');
      return;
    }

    const navList = document.createElement('ul');
    const navParent = this.querySelector('.ds-article-navigation')

    let counter = 0
    headings.forEach((heading) => {
      const headingId = `nav-${counter}`
      heading.id = headingId
      const listItem = document.createElement('li');
      const anchor = document.createElement('a');
      anchor.textContent = heading.textContent.trimStart();
      anchor.href = `#${heading.id}`;
      listItem.appendChild(anchor);
      navList.appendChild(listItem);
      counter++
    });

    navParent.appendChild(navList);
  }
}

if (!window.customElements.get("ds-article-content")) {
  customElements.define('ds-article-content', DSArticleContent);
}